import axios from '../../../apis/Api'
import history, { logout } from '../../../history'
import storage from '../../../apis/Storage'
import {
  ADD_BUSINESS_ENTITY_TYPE,
  DELETE_BUSINESS_ENTITY_TYPE,
} from '../../../Types'
import { toast } from 'react-toastify'
import { showLoading, hideLoading } from 'react-redux-loading-bar'

export const addBusinessEntityType = (formValues) => async (dispatch) => {
  dispatch(showLoading())
  await axios
    .post('api/BusinessEntityType', formValues)
    .then(({ data }) => {
      if (data.response)
        dispatch({
          type: ADD_BUSINESS_ENTITY_TYPE,
          payload: data.response,
        })
      dispatch(hideLoading())
      toast.success('Business Entity Type added successfully')
    })
    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = ''
          var errors = error.response.data.errors
          var keys = Object.keys(errors)
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + ' , \n'
          }
          toast.error(errorMessage)
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          )
        else {
          toast.error('Error while processing the request')
        }
      } else toast.error('Error while processing the request')
    })
}

export const deleteBusinessEntityType = (id) => async (dispatch) => {
  const config = {
    headers: { Authorization: `Bearer ${storage.get('_appToken')}` },
  }

  await axios
    .delete(`api/BusinessEntityType/${id}`, config)
    .then(() => {
      toast.success('Business Entity Type deleted successfully')
      dispatch({ type: DELETE_BUSINESS_ENTITY_TYPE, payload: id })
    })
    .catch(function (error) {
      dispatch(hideLoading())
      toast.error('Error: ' + error)
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (error.response.data) toast.error(error.response.data.Message ? error.response.data.Message : error.response.data.message)
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}
